import { Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import qs from 'qs';

function BidProposalSubmitResultContainer() {
  const { result } = qs.parse(window.location.search, {
    ignoreQueryPrefix: true,
  });

  return (
    <>
      <Row justify="center" style={{ marginTop: '120px' }}>
        <Col span={9}>
          <Title level={2}>
            견적금액이{' '}
            {result === 'success'
              ? '정상적으로 제출 되었습니다.'
              : '제출되지 않았습니다.'}
          </Title>
        </Col>
      </Row>
    </>
  );
}

export default BidProposalSubmitResultContainer;
